module.exports = __webpack_public_path__ + "media/Yang.Lc - 回忆太拥挤.92586cf0.flac";